const isDemo = process.env.REACT_APP_THEME === 'demo';

export default () => ({
  base: {
    // borderRight: '1px solid #656565',
    marginRight: 10,
    // paddingRight: 40,
    marginLeft: 'auto',
    height: 38,
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  menuItem: {
    padding: 0,
    height: 'unset',
    '&:hover,&:focus': {
      backgroundColor: 'white',
    },
  },
  sublist: {
    flexDirection: 'column',
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paper: {
      margin: 0,
    },
  },
  panel: {
    boxShadow: 'none',
    width: '100%',
    '&:before': {
      backgroundColor: 'white',
    },
    margin: 0,
  },
  header: {
    paddingLeft: 16,
    fontSize: 18,
    paddingTop: 8,
    fontWeight: 600,
  },
  heading: {
    fontSize: 14,
  },
  simpleRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingLeft: 16,
    paddingRight: 20,
    minHeight: 36,
  },
  yesIcon: {
    color: isDemo ? '#10b981' : '#79f5ab',
    marginRight: 8,
    fontSize: '15px',
  },
  noIcon: {
    color: '#FF5656',
    marginRight: 8,
    fontSize: '15px',
  },
  pendingIcon: {
    color: isDemo ? '#f59e0b' : '#FFB547',
    marginRight: 8,
    fontSize: '15px',
  },
  countText: {
    marginLeft: 'auto',
    paddingRight: 8,
    color: '#9e9e9e',
    fontSize: 13,
  },
  detailText: {
    color: '#9e9e9e',
    fontSize: 13,
  },
  row: {
    display: 'flex',
    paddingLeft: 16,
    paddingRight: 20,
    alignItems: 'center',
    minHeight: 36,
  },
  childRow: {
    display: 'flex',
    paddingLeft: 40,
    paddingRight: 20,
    alignItems: 'center',
    minHeight: 32,
  },
  noPadding: {
    padding: 0,
  },
});
